import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2188717590 from "../../../../../packages/component/src/components/step/demo/demo1.js?loadDemo";
import legacyImportDemo_3387890005 from "../../../../../packages/component/src/components/step/demo/demo2.js?loadDemo";
import legacyImportDemo_2655508756 from "../../../../../packages/component/src/components/step/demo/demo3.js?loadDemo";
import legacyImportDemo_130942803 from "../../../../../packages/component/src/components/step/demo/demo4.js?loadDemo";
import legacyImportDemo_2441153554 from "../../../../../packages/component/src/components/step/demo/demo5.js?loadDemo";
import legacyImportDemo_2950694737 from "../../../../../packages/component/src/components/step/demo/demo6.js?loadDemo";
import legacyImportDemo_43298064 from "../../../../../packages/component/src/components/step/demo/demo7.js?loadDemo";
import legacyImportDemo_38282591 from "../../../../../packages/component/src/components/step/demo/demo8.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2188717590,
  legacyImportDemo_3387890005,
  legacyImportDemo_2655508756,
  legacyImportDemo_130942803,
  legacyImportDemo_2441153554,
  legacyImportDemo_2950694737,
  legacyImportDemo_43298064,
  legacyImportDemo_38282591,
  React
};